module.exports = __webpack_public_path__ + "img/Phencyclidine (PCP).f6d54241.png";